/**
 * @module getSnackBarTimeout
 */

import store from '../store/store';
import { CLIENT_DEFAULT_SNACKBAR_TIMEOUT } from '../constants';

/**
 * @function
 * To get the snack bar timeout from the satchel store
 * @returns The snack bar timeout
 */

const getSnackBarTimeout = () => {
    let timeout = null;
    if (store.cache.data?.clientTimeouts?.default?.SnackBarTimeoutInMsec) {
        timeout = store.cache.data.clientTimeouts.default.SnackBarTimeoutInMsec;
    }
    return timeout !== null ? timeout : CLIENT_DEFAULT_SNACKBAR_TIMEOUT;
};

export default getSnackBarTimeout;
